import { colors } from '@ui/colors'
import { hex } from '@ui/utils/hex'

export const WIDTH = 80
export const GAP = 32
export const WIDTH_SIDE = 24

export const sContainer = 'gap-16 px-16 pb-96 pt-8'
export const sRow = 'flex w-full flex-row items-center justify-between'
export const sButtonWrapper = 'flex h-6 items-center justify-center'
export const sFieldInactive = 'bg-gray-50'
export const sViewFieldContainer =
  'items-center justify-center rounded-md border border-black/10'

export const backgroundColorViewField = hex(colors.black, 0.02)
